module.exports = __webpack_public_path__ + "static/img/072_TO8_1699_og.3ce74da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/072_TO8_1699_og.jpg
// module id = c4TQ
// module chunks = 0